import './prodConsole';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@phosphor-icons/web/regular';
import '@phosphor-icons/web/bold';
import '@phosphor-icons/web/fill';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';

/** Benign browser warning — CRA dev overlay treats it as fatal when layout observers nest. */
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const resizeObserverLoop =
    /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
  window.addEventListener('error', (event) => {
    if (resizeObserverLoop.test(event.message || '')) {
      event.stopImmediatePropagation();
    }
  });
}

/** Cesium Workers / Assets load from public/cesium (see scripts/copy-cesium-assets.cjs). */
if (typeof window !== 'undefined') {
  const prefix = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  // Must be path-absolute from site root when PUBLIC_URL is empty: `${''}cesium/` was `cesium/`,
  // which resolves to /studio/.../cesium/ on nested routes and 404s (HTML MIME → worker failures).
  window.CESIUM_BASE_URL = `${prefix}/cesium/`.replace(/([^:]\/)\/+/g, '$1');
}

const rootElement = document.getElementById('root');
const app = (
  <AuthProvider>
    <App />
  </AuthProvider>
);

// Prerendered marketing HTML (optional npm run seo:snap) — hydrate instead of replace.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  const root = ReactDOM.createRoot(rootElement);
  // StrictMode disabled so the 3D viewer (SuperSplat) mounts once. Double-mount was leaving the wrong
  // viewer instance in the DOM and aborting the load that had splats.
  root.render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
